import { render, staticRenderFns } from "./MoreInformation.vue.html?vue&type=template&id=43de4e80&scoped=true&"
import script from "./MoreInformation.component.js?vue&type=script&lang=vueJs&"
export * from "./MoreInformation.component.js?vue&type=script&lang=vueJs&"
import style0 from "./MoreInformation.scoped.scss?vue&type=style&index=0&id=43de4e80&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43de4e80",
  null
  
)

export default component.exports